<script lang="ts">
	import type { CakeProps } from "../../templates/WeddingsProps";
	import Link from "../Link.svelte";
	import StaticPicture from "../Picture/StaticPicture.svelte";
	import pinterest from "../../assets/images/pinterest.png?w=60&webp&imagetools";
	import { nbspify } from "../../../../core/utils/nbspify";

	export let index: number;
	export let cake: CakeProps;
</script>

<div
	class="group relative flex max-w-[13.5rem] flex-col items-center gap-6 lg:max-w-[18rem] xl:basis-[calc((100%-((3*1.5rem)))/4)] xl:gap-y-5"
>
	<div class="flex w-full items-center gap-3">
		<div
			class="flex h-6 w-6 items-center justify-center rounded-full border border-secondary bg-white text-base font-semibold lg:h-8 lg:w-8 lg:text-md"
		>
			{index + 1}
		</div>
		<span class="text-md font-semibold capitalize leading-[1] lg:text-lg">{nbspify(cake.name ?? "")}</span>
	</div>
	<div
		class="relative h-[16.5rem] max-h-[16.5rem] w-[13.5rem] cursor-pointer rounded-lg after:absolute after:inset-[-.25rem] after:m-auto after:h-[calc(100%+(2*0.25rem))] after:w-[calc(100%+(2*0.25rem))] after:rounded-lg after:border-2 after:border-secondary after:opacity-0 after:transition-opacity after:duration-300 after:content-[''] group-hover:after:opacity-100 lg:h-[22.5rem] lg:max-h-[22.1875rem] lg:w-[18rem] xl:h-auto xl:w-[initial]"
	>
		<StaticPicture
			class="h-full w-full overflow-hidden rounded-lg"
			image={cake.image}
			alt={cake.alt ?? "Fotografie – ukázka svatebního dortu"}
			height={360}
			width={288}
			loading="lazy"
		/>
		<StaticPicture
			class="absolute bottom-4 right-4 h-10 w-10 lg:h-12 lg:w-12"
			image={pinterest}
			alt="Ikona Pinterestu"
			height={48}
			width={48}
			loading="lazy"
		/>
	</div>
	<div class="max-w-[13.5rem] min-[500px]:max-w-[initial]">
		{#each cake.desc as desc}
			<p class="mt-2 whitespace-normal">{nbspify(desc)}</p>
		{/each}
	</div>
	<Link
		class="absolute inset-0 h-full w-full"
		href={cake.urlSlug}
		aria-label={cake.name ?? "Fotografie dortu"}
		target="_blank"
	></Link>
</div>
